export class Pesata {
  organizzazioneId: number;
  id: number;
  codice: string;
  descrizione: string;
  isActive: boolean;
  dataPesata: number;
  statoBilancia: string;
  numeroBilancia: number;
  pesoNetto: number;
  pesoLordo: number;
  pesoTara: number; 
  numeroPezzi: number;
  pesoMedioUnitario: number;
  unitaMisura: string;
}
